import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo.svg'


const _hoisted_1 = {
  class: "surface-overlay px-4 md:px-6 lg:px-8 flex align-items-center justify-content-center relative",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = { class: "surface-card p-5 shadow-2 border-round w-full lg:w-6 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Smsify",
  height: "80",
  class: "mb-4"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Finishing Twilio connection…", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0" }, "Verifying your authorization with Twilio. This only takes a moment.", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle text-green-500 text-5xl" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Twilio connected!", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, "Taking you back to your settings…", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times-circle text-orange-500 text-5xl" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Connection cancelled", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, " It looks like the Twilio authorization was declined or didn't complete. You can try again whenever you're ready. ", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-red-500 text-5xl" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Connection failed", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, " Twilio didn't confirm the authorization. This can happen if the flow was interrupted — please try connecting again. ", -1)
const _hoisted_20 = { key: 4 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-red-500 text-5xl" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Account already linked", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, " That Twilio account is already connected to a different Smsify user. Please use another Twilio account, or disconnect it from the other user first. ", -1)
const _hoisted_24 = { key: 5 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock text-orange-500 text-5xl" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Session expired", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, " Your Smsify session expired while you were on Twilio's site. Please log back in, then click \"Connect with Twilio\" again. ", -1)
const _hoisted_28 = { key: 6 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-red-500 text-5xl" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-2xl font-medium mt-3 mb-2" }, "Something went wrong", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-600 line-height-3 m-0 mb-4" }, " We couldn't complete the connection. Please try again from your settings page. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.status === 'processing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ProgressSpinner, { style: {"width":"50px","height":"50px"} }),
            _hoisted_5,
            _hoisted_6
          ]))
        : (_ctx.status === 'success')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
          : (_ctx.status === 'cancelled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createVNode(_component_Button, {
                  label: "Back to Settings",
                  icon: "pi pi-arrow-left",
                  onClick: _ctx.goToSettings
                }, null, 8, ["onClick"])
              ]))
            : (_ctx.status === 'rejected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _createVNode(_component_Button, {
                    label: "Try Again",
                    icon: "pi pi-refresh",
                    class: "mr-2",
                    onClick: _ctx.retryAuthorize
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    label: "Back to Settings",
                    severity: "secondary",
                    outlined: "",
                    onClick: _ctx.goToSettings
                  }, null, 8, ["onClick"])
                ]))
              : (_ctx.status === 'conflict')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode(_component_Button, {
                      label: "Back to Settings",
                      icon: "pi pi-arrow-left",
                      onClick: _ctx.goToSettings
                    }, null, 8, ["onClick"])
                  ]))
                : (_ctx.status === 'sessionExpired')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _createVNode(_component_Button, {
                        label: "Log In",
                        icon: "pi pi-sign-in",
                        onClick: _ctx.goToLogin
                      }, null, 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _createVNode(_component_Button, {
                        label: "Back to Settings",
                        icon: "pi pi-arrow-left",
                        onClick: _ctx.goToSettings
                      }, null, 8, ["onClick"])
                    ]))
    ])
  ]))
}